export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-secondary-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-sm"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                香蕉漫画网
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              香蕉漫画网致力于为广大漫迷提供韩漫、日漫、国漫的精准分类导航服务，让每一部好漫画都被看见。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#cards" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  精选漫画推荐
                </a>
              </li>
              <li>
                <a href="#ranking" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  热度榜单
                </a>
              </li>
              <li>
                <a href="#updates" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  最新更新动态
                </a>
              </li>
              <li>
                <a href="#index" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  漫画分类索引
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  常见问答
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              漫画资源
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#carousel" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  焦点专题
                </a>
              </li>
              <li>
                <a href="#media" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  精彩推荐
                </a>
              </li>
              <li>
                <a href="#topics" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  热门话题
                </a>
              </li>
              <li>
                <a href="#comments" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  读者热评
                </a>
              </li>
              <li>
                <a href="#app" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  移动端体验
                </a>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于香蕉漫画网
                </a>
              </li>
              <li>
                <a href="#features" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  平台特色
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  读者投稿与联系
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Partners Section */}
        <div className="border-t border-background-300/60 pt-8 md:pt-10 mb-8 md:mb-10">
          <h4 className="font-heading text-sm font-semibold text-foreground-700 mb-4">
            合作伙伴
          </h4>
          <div className="flex flex-wrap gap-4 md:gap-6">
            <span className="text-sm text-foreground-400">待添加合作伙伴</span>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-300/60 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            &copy; 2026 香蕉漫画网. 本站仅供漫画导航与学习交流，请支持正版漫画。
          </p>
          <div className="flex items-center gap-4">
            <a href="#about" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              关于我们
            </a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              常见问题
            </a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}